import { Tracker, TrackerUserProperties, TrackingEvent } from './tracker';
import { User } from '../../auth/interfaces/user';
import { ExecIfDefined } from '../../shared/utils/decorators';

declare const FS: {
  restart: VoidFunction;
  identify: (identity: string) => void;
  shutdown: VoidFunction;
  setUserVars: (params: TrackerUserProperties) => void;
  event: (event: TrackingEvent) => void;
};

export class FullstoryService implements Tracker {
  @ExecIfDefined('FS')
  start() {
    FS.restart();
  }

  @ExecIfDefined('FS')
  stop() {
    FS.shutdown();
  }

  @ExecIfDefined('FS')
  reset() {}

  @ExecIfDefined('FS')
  setIdentity(user: User) {
    FS.identify(user.email);
    FS.setUserVars({
      userId: user.id,
      displayName: user.name,
      email: user.email,
      role: user.role
    });
  }

  @ExecIfDefined('FS')
  updateUserProperties() {}

  @ExecIfDefined('FS')
  track(event: TrackingEvent) {
    FS.event(event);
  }

  @ExecIfDefined('FS')
  pageTrack() {}
}

export const fullstoryService = new FullstoryService();
